import React from "react";
import ReactDom from "react-dom";
import CompareComponent from "./compare-component";
import CompareItem from "./compare-item";

export default class CompareComponentRenderer {
    constructor(container, comparePageUrl, translations ) {
        this._container = container;
        this._comparePageUrl = comparePageUrl;
        this._translations = translations ;
    }

    render() {
        ReactDom.render(<CompareComponent comparePageUrl={this._comparePageUrl} translations={this._translations } />,
            this._container);
    }
}